import { PDFViewer } from '@react-pdf/renderer';
import Loading from 'components/loading';
import styles from './ocr.module.scss';
import { OCRPdf } from './ocr-pdf';
import ocr from './ocr';

const Section = ({
	pending,
	application,
	log,
	file,
	fileGuarantors,
	handleFileChange,
	handleFileChangeGuarantor,
}: ocr.SectionProps) => {
	return (
		<>
			{!pending && log && (
				<div className={styles.pdf}>
					<PDFViewer style={{ width: '100%', height: 'calc(100vh - 150px)' }}>
						<OCRPdf application={application} />
					</PDFViewer>
				</div>
			)}

			{!log && !pending && (
				<>
					<div className={styles.inputBox}>
						<h3 className={styles.container_input}>Client</h3>
						<label className={styles.fileInput}>
							<div className={styles.fileInputTitle}>CRIF:</div>
							{file?.name ?? (
								<div className={styles.fileInputDescription}>
									Upload <span className={styles.bold}>.pdf</span> document
								</div>
							)}
							<input accept="application/pdf" type="file" onChange={handleFileChange} />
						</label>
					</div>
					{fileGuarantors.map((fg, index) => (
						<div className={styles.inputBox} key={index}>
							<h3 className={styles.container_input}>Guarantor</h3>
							<label className={styles.fileInput}>
								<div className={styles.fileInputTitle}>CRIF:</div>
								{fg?.name ?? (
									<div className={styles.fileInputDescription}>
										Upload <span className={styles.bold}>.pdf</span> document
									</div>
								)}
								<input
									accept="application/pdf"
									type="file"
									onChange={(event) => handleFileChangeGuarantor(event, index)}
								/>
							</label>
						</div>
					))}
				</>
			)}

			{pending && (
				<div
					style={{
						width: '100%',
						background: '#fff',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Loading />
				</div>
			)}
		</>
	);
};

export default Section;
